<template>
	<div
		class="w-full rounded-xl bg-white overflow-hidden border border-gray-100 self-stretch flex flex-col"
		:class="containerClass"
	>
		<div
			v-if="showHeader"
			class="p-3 border-b border-gray-100 flex items-center justify-between"
			:class="headerClass"
		>
			<!-- if the header slot is passed, render it -->
			<slot v-if="$slots.header" name="header"></slot>

			<!-- if the header slot is not passed, render a default header -->
			<template v-else>
				<div class="flex flex-1 items-center space-x-3">
					<slot v-if="$slots.headerLeft" name="headerLeft"></slot>

					<h3 class="text-base line-clamp-1 text-gray-700">
						{{ headerTitle }}
					</h3>
				</div>

				<slot v-if="$slots.headerRight" name="headerRight"></slot>
			</template>
		</div>

		<div class="p-3 flex-1" :class="contentClass">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		containerClass: {
			type: String,
			default: ""
		},
		contentClass: {
			type: String,
			default: ""
		},
		headerClass: {
			type: String,
			default: ""
		},
		headerIcon: {
			type: String,
			default: ""
		},
		headerTitle: {
			type: String,
			default: ""
		},
		showHeader: {
			type: Boolean,
			default: true
		}
	}
};
</script>
